import { Component, input, OnInit, output, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { WidgetAction, WidgetEvent, WidgetInstance } from '@iot-platform/models/widgets';
import { TranslatePipe } from '@ngx-translate/core';
import { WidgetLoaderDirective } from '../../directives/widget-loader.directive';

@Component({
  imports: [WidgetLoaderDirective, TranslatePipe, FlexLayoutModule, MatMenuModule, MatIconModule, MatButtonModule],
  selector: 'iot-platform-ui-widget-item',
  templateUrl: './widget-item.component.html',
  styleUrls: ['./widget-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class]': 'hostCssClass()'
  }
})
export class WidgetItemComponent implements OnInit {
  widget = input<WidgetInstance>();
  dispatchEvent = output<WidgetEvent>();

  hostCssClass: WritableSignal<string> = signal('');

  get menu() {
    return this.widget()?.options.menu;
  }

  ngOnInit(): void {
    this.hostCssClass.set(`widget-item_${this.widget()?.type.toLowerCase()}`);
  }

  onWidgetClick(): void {
    this.dispatchEvent.emit({ action: WidgetAction.PREVIEW, widget: this.widget() as WidgetInstance });
  }

  onDispatchEvent(action: WidgetAction): void {
    this.dispatchEvent.emit({ action, widget: this.widget() as WidgetInstance });
  }
}
